// extracted by mini-css-extract-plugin
module.exports = {"Section3":"Section3_Section3__mAe92","ImageList":"Section3_ImageList__LEWoj","CardList":"Section3_CardList___cTtW"};